import { render, staticRenderFns } from "./StatisticBar.vue?vue&type=template&id=7604e64e&"
import script from "./StatisticBar.vue?vue&type=script&lang=js&"
export * from "./StatisticBar.vue?vue&type=script&lang=js&"
import style0 from "./StatisticBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports